import styled from '@emotion/styled';
import { TextField } from '@mui/material';

const StyledTextField = styled(TextField)`
    input {
        &:focus {
            outline: none;
        }
    }
`;

export default StyledTextField;
